import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TabletLandscape"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 9.75H19.5V14.25H18V9.75ZM22.5 18.75V5.25C22.4988 4.42209 21.8279 3.75124 21 3.75H3C2.17192 3.75083 1.50083 4.42192 1.5 5.25V18.75C1.50083 19.5781 2.17192 20.2492 3 20.25H21C21.8281 20.2492 22.4992 19.5781 22.5 18.75ZM21 18.75H3V5.25H21V18.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TabletLandscape.vue"]]);
